import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import type { OnInit } from '@angular/core';
import { Component, NgModule, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import type { Observable } from 'rxjs';
import type { IDialogContentComponent } from '../../modal-dialog/modal-dialog.service';
import type { PdfJsViewerComponent } from 'ng2-pdfjs-viewer';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Document } from '../common.dialog.service';

@Component({
  selector: 'app-pdf-viewer-popup',
  templateUrl: './pdf-viewer-popup.component.html',
  styleUrls: ['./pdf-viewer-popup.component.scss']
})
export class PdfViewerPopupComponent implements OnInit, IDialogContentComponent<void, Document[]> {
  @ViewChild('pdfViewer') public pdfViewer: PdfJsViewerComponent;

  input?: Document[] | undefined;
  reportControl: FormControl = new FormControl();
  imagePath: string | undefined;

  constructor(private readonly http: HttpClient) {}

  getResult(): void {}

  isDisabled(): boolean {
    return false;
  }

  ngOnInit(): void {
    if (this.input && this.input.length > 0) {
      this.reportControl.valueChanges.subscribe(value => {
        this.imagePath = undefined;
        if (this.isPdfUrl(value as string)) {
          this.downloadFile(value as string).subscribe(
            (res: any) => {
              this.pdfViewer.pdfSrc = res; // pdfSrc can be Blob or Uint8Array
              this.pdfViewer.refresh(); // Ask pdf viewer to load/refresh pdf
            }
          );
        } else {
          this.imagePath = value;
        }
      });
      this.reportControl.setValue(this.input[0].url);
    }
  }

  /**
   * Check if URL points to a PDF file.
   * Handles URLs with query parameters (e.g., file.pdf?expires=...&signature=...)
   * and REST-style PDF endpoints (e.g., /report/123/pdf)
   */
  private isPdfUrl(url: string): boolean {
    if (!url) return false;
    const pathWithoutQuery = url.split('?')[0].toLowerCase();
    return pathWithoutQuery.endsWith('.pdf') || pathWithoutQuery.endsWith('/pdf');
  }

  private downloadFile(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: 'blob' });
  }
}

@NgModule({
  declarations: [PdfViewerPopupComponent],
  imports: [
    CommonModule,
    TranslateModule,
    PdfJsViewerModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule
  ],
  providers: [
    HttpClient
  ]
})
export class PdfViewerPopupModule { }
